import angular from 'angular'

angular.module('vend.ui').directive('vdExpandableContent', function () {
  return {
    link($scope, $element, $attrs) {
      /**
       * Add the vd-expandable-content class to the expandable element
       */
      $attrs.$addClass('vd-expandable-content')
    },
  }
})
